import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { SharedItemMessage } from "@/Common/Models/Portal/SharedItem/SharedItemMessage";
import { SharedItemPriority } from "@/Common/Models/Portal/SharedItem/SharedItemPriority";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";
import { Tag } from "@/DesignSystem";

import styles from "./PortalCommunicationPreviewList.module.scss";

interface PortalCommunicationPreviewListProps {
    sharedItemMessages: SharedItemMessage[];
}

function PortalCommunicationPreviewList(props: Readonly<PortalCommunicationPreviewListProps>): JSX.Element {
    const { getText } = useTranslation();

    if (!props?.sharedItemMessages)
        return null;

    const formatDate = (date: Date): string => LuxonDateTimeParser.parse(date)?.toFormat("yyyy-MM-dd") ?? "";

    const sortedMessages = [...props.sharedItemMessages].sort((a, b) => (new Date(b.DateCreated).getTime() - new Date(a.DateCreated).getTime()));
    const messages = sortedMessages.slice(0, 3);

    let tagStyle = "";
    if (sessionStore.locale === "en" && messages.some(p => p.IsFromPatient)) {
        tagStyle = styles.en;
    }
    else if (sessionStore.locale === "fr" && messages.some(p => !p.IsFromPatient)) {
        tagStyle = styles.fr;
    }
    else if (sessionStore.locale === "es") {
        tagStyle = styles.es;
    }

    return (
        <div className={styles.portalCommunicationListContainer}>
            {messages.map(message => {
                const unreadCssClass = (message.IsFromPatient && !!message.DateReadByUser) || !message.IsFromPatient ? "" : styles.unreadMessage;
                const priorityText = getText(`Enums_SharedItemPriority_${SharedItemPriority[message?.Priority ?? SharedItemPriority.Normal]}`);
                const messageText = message.SharedItemSubject ? message.SharedItemSubject : (message.Text ?? "");

                return (
                    <div className={styles.threadContainer} key={`portalCommunicationPreviewList_${message.SharedItemMessageId}`}>
                        <div className={styles.threadInfoContainer}>
                            <div className={`${styles.iconContainer} ${tagStyle}`}>
                                {message.IsFromPatient
                                    ? <Tag label={getText("ReceivedLabel")} variant="success" size="sm" />
                                    : <Tag label={getText("SentLabel")} variant="brand" size="sm" />
                                }
                            </div>
                            <span className={`${styles.messageContainer} ${unreadCssClass}`} title={messageText} data-cy="portalCommunicationPreviewList-message-info">
                                {`${formatDate(message.DateCreated)} - [${priorityText}] - ${messageText}`}
                            </span>
                        </div>
                        <div className={styles.attachmentLink} />
                    </div>
                );
            })}
        </div>
    );
}

export { PortalCommunicationPreviewList };
